document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('countryLangModal');
  if (!modal) return;

  const overlay = modal.querySelector('.country-lang-modal__overlay');
  const closeBtn = document.getElementById('closeModal');
  const continueBtn = document.getElementById('saveAndContinue');
  const countrySelect = document.getElementById('countrySelect');
  const languageSelect = document.getElementById('languageSelect');

  // ── LocalStorage key & expiration (30 days) ──
  const STORAGE_KEY = 'bootyparlor_country_lang_preference';
  const EXPIRATION_DAYS = 30;
  const MODAL_SEEN_PARAM = 'modal_seen'; // Query param for cross-domain

  function hasSeenModalRecently() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return false;

    try {
      const data = JSON.parse(saved);
      const savedTime = new Date(data.timestamp);
      const now = new Date();
      const diffDays = (now - savedTime) / (1000 * 60 * 60 * 24);
      return diffDays < EXPIRATION_DAYS;
    } catch (e) {
      return false;
    }
  }

  function markAsSeen() {
    const data = {
      timestamp: new Date().toISOString(),
      seen: true
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  // Check for cross-domain "seen" signal from URL param
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has(MODAL_SEEN_PARAM)) {
    markAsSeen();
    // Clean URL (remove param without reload)
    urlParams.delete(MODAL_SEEN_PARAM);
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
    history.replaceState(null, '', newUrl);
  }

  const isUaeDomain = window.location.host.includes('ae.bootyparlor.com');

  // Auto-show only if not seen recently + not on main UAE domain
  if (!hasSeenModalRecently() && !isUaeDomain) {
    setTimeout(() => {
      modal.classList.add('active');
    }, 1400);
  }

  const closeModal = (shouldSave = true) => {
    modal.classList.remove('active');
    if (shouldSave) {
      markAsSeen();
    }
  };

  // Close handlers (save on close/X/overlay)
  overlay?.addEventListener('click', () => closeModal(true));
  closeBtn?.addEventListener('click', () => closeModal(true));

  // Continue handler – SAVE ALWAYS, even if redirect happens
  continueBtn?.addEventListener('click', () => {
    const selectedCountry = countrySelect?.value;
    const selectedLang = languageSelect?.value;

    let redirectUrl = null;
    let needsRedirect = false;

    // Prepare country redirect
    if (selectedCountry === 'uae' && !window.location.host.includes('ae.')) {
      redirectUrl = `https://ae.bootyparlor.com${window.location.pathname}${window.location.search}`;
      needsRedirect = true;
    } else if (selectedCountry === 'sa' && window.location.host.includes('ae.')) {
      redirectUrl = `https://sa.bootyparlor.com${window.location.pathname}${window.location.search}`;
      needsRedirect = true;
    }

    // Prepare language path change
    const currentIsArabic = window.location.pathname.includes('/ar');
    if (
      (selectedLang === 'ar' && !currentIsArabic) ||
      (selectedLang === 'en' && currentIsArabic)
    ) {
      let newPath = window.location.pathname;

      if (selectedLang === 'ar' && !currentIsArabic) {
        newPath = newPath.replace(/\/$/, '') + '/ar';
      } else if (selectedLang === 'en' && currentIsArabic) {
        newPath = newPath.replace(/\/ar(\/|$)/, '$1') || '/';
      }

      // If already redirecting domain, combine with new path
      if (redirectUrl) {
        const redirectObj = new URL(redirectUrl);
        redirectObj.pathname = newPath;
        redirectUrl = redirectObj.toString();
      } else {
        redirectUrl = `${window.location.origin}${newPath}${window.location.search}`;
        needsRedirect = true;
      }
    }

    // ALWAYS mark as seen before redirect (or on no-change)
    markAsSeen();

    if (needsRedirect && redirectUrl) {
      // Add seen param for cross-domain persistence
      const redirectObj = new URL(redirectUrl);
      redirectObj.searchParams.set(MODAL_SEEN_PARAM, '1');
      window.location.href = redirectObj.toString();
    } else {
      // No change → just close
      closeModal(false); // Already saved above
    }
  });
});